import React, { useMemo } from "react";
import { LinkedContent } from "./LinkedContent";
import { graphql, useFragment } from "react-relay";
import { AHSeparator } from "arkh";
import { LinkedContentInput_images$key } from "./__generated__/LinkedContentInput_images.graphql";
import { LinkedContentInput_files$key } from "./__generated__/LinkedContentInput_files.graphql";
import { LinkedContentToolbar } from "./LinkedContentToolbar";

export function LinkedContentInput(props: {
  images: LinkedContentInput_images$key;
  files: LinkedContentInput_files$key;
  openFile: (file: {
    fileId: string;
    fileName: string;
    fileType: string;
    url: string;
  }) => void;
  removeFile?: (id: string) => void;
  removeImage?: (id: string) => void;
  openLinkFile: () => void;
  openImagePicker: () => void;
  disabled?: boolean;
}) {
  const images = useFragment(
    graphql`
      fragment LinkedContentInput_images on Image @relay(plural: true) {
        ...LinkedContent_images
      }
    `,
    props.images
  );

  const files = useFragment(
    graphql`
      fragment LinkedContentInput_files on File @relay(plural: true) {
        ...LinkedContent_files
      }
    `,
    props.files
  );

  const hasLinkedContent = useMemo(() => {
    return files.length > 0 || images.length > 0;
  }, [files.length, images.length]);

  return (
    <>
      {hasLinkedContent ? (
        <>
          <AHSeparator />
          <LinkedContent
            disabled={props.disabled}
            images={images}
            files={files}
            openFile={props.openFile}
            removeFile={props.removeFile}
            removeImage={props.removeImage}
          />
        </>
      ) : null}
      {props.disabled ? null : (
        <>
          <AHSeparator />
          <LinkedContentToolbar
            disabled={props.disabled}
            openImagePicker={props.openImagePicker}
            openLinkFile={props.openLinkFile}
          />
        </>
      )}
    </>
  );
}
